import { connect } from "react-redux";
import React from "react";
import {
  Box,
  Heading,
  Table,
  Text,
  VStack,
} from "@chakra-ui/react";
import _ from "lodash";
import OrganizationTicketsLineGraph from "../../charts/daily/OrganizationTicketsLineGraph";

const { formatNumber, formatPercent } = require("../../../../store/helpers");

const OrganizationTicketsTable = ({ table, chart }) => {
  return (
    <Box mt={10}>
      <Box>
        {table.map((a, index) => (
          <Box className="reportContainer">
            <Box mb="20px">
              <Heading fontSize="30px" color="#222" fontWeight="700">
                {index + 1}. {a.name}
              </Heading>
            </Box>
            <Table.Root key={index} className="stripedTable" size="sm">
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
                  <Table.ColumnHeader>Avg /Hour.</Table.ColumnHeader>
                  <Table.ColumnHeader>Min.</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Max</Table.ColumnHeader>
                  <Table.ColumnHeader>Completed</Table.ColumnHeader>
                  <Table.ColumnHeader>No Show</Table.ColumnHeader>
                  <Table.ColumnHeader>Unattended</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text color={"var(--blue)"}>{formatNumber(a.total)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatNumber(a.averageTicketsPerHour)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatNumber(a.minTicketsPerHour)}</Text>
                  </Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text>{formatNumber(a.maxTicketsPerHour)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <VStack gap="2px" alignItems="flex-start">
                      <Text color={"var(--green)"}>
                        {formatNumber(a.completed)}
                      </Text>
                      <Box
                        color="gray.500"
                        fontWeight="semibold"
                        fontSize="xs"
                        textTransform="uppercase"
                      >
                        ({formatPercent(a.pctCompleted)})
                      </Box>
                    </VStack>
                  </Table.Cell>
                  <Table.Cell>
                    <VStack gap="2px" alignItems="flex-start">
                      <Text cursor="pointer" color={"var(--red)"}>
                        {formatNumber(a.noShow)}
                      </Text>
                      <Box
                        color="gray.500"
                        fontWeight="semibold"
                        fontSize="xs"
                        textTransform="uppercase"
                      >
                        ({formatPercent(a.pctNoShow)})
                      </Box>
                    </VStack>
                  </Table.Cell>
                  <Table.Cell>
                    <VStack gap="2px" alignItems="flex-start">
                      <Text color={"var(--red)"}>
                        {formatNumber(a.unattended)}
                      </Text>
                      <Box
                        color="gray.500"
                        fontWeight="semibold"
                        fontSize="xs"
                        textTransform="uppercase"
                      >
                        ({formatPercent(a.pctUnattended)})
                      </Box>
                    </VStack>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell colSpan={9} p={0}>
                    <Box mt="20px" mb="20px">
                      <OrganizationTicketsLineGraph
                        title={`Entire Organization: Hour by hour comparison`}
                        chart={chart}
                        chartHeight="300px"
                      />
                    </Box>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table.Root>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  const { defaultReducer } = state;
  return {
    tickets: defaultReducer.tickets,
  };
};

export default connect(mapStateToProps, {})(OrganizationTicketsTable);
